<template>
  <header id="header" class="alt">
    <span class="logo" v-if="logo != null"
      ><img :src="require(`@/assets/images/${logo}`)" alt="logo"
    /></span>
    <h1>{{ title }}</h1>
    <p>{{ description }}</p>
  </header>
</template>

<script>
export default {
  name: "SiteHeader",
  props: ["title", "description", "logo"],
};
</script>
